module.exports = __webpack_public_path__ + "static/media/Ecommerce@2x.94990ccb.png";